<template>
    <div>
        <breadCrumb 
            :icon="'fa-gifts'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_reward`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 p-3 d-block">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <div class="dataTables_filter">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="search" @keypress.enter="filterSearchReward">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchReward">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <date-range-picker class="w-100 mb-2"
                                :minDate="minDate"
                                ref="picker"
                                v-model="dateRange"
                                :opens="'right'"
                                :autoApply="true"
                                :showDropdowns="true" 
                                :always-show-calendars="false"
                                :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                                @showCustomRange="showCustomRangeCalendars=true"
                                @update="filterByDate">
                            </date-range-picker>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0" >
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                            <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid">
                                        <thead class="thead-themed">
                                            <tr>
                                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(items, i, j) in rewardItems" :key="j">
                                            <tr class="dtrg-group dtrg-start dtrg-level-0">
                                                <td colspan="5">
                                                    <span class="text-secondary mr-2"><i class="fas fa-store"></i></span>{{getOutletName(items[0].outletID)}} 
                                                </td>
                                            </tr>
                                            <tr v-for="(item, k) in items" :key="k">
                                                <td class="align-middle">{{k+startPage}}</td>
                                                <td class="align-middle">{{convertTimestampToDateTime(item.createDate)}}</td>
                                                <td class="align-middle">{{item.title}}</td>
                                                <td class="align-middle">{{item.memberDisplayName}}</td>
                                                <td class="align-middle">{{item.mobile}}</td>
                                            </tr>
                                        </tbody>
                                        <!-- <tbody>
                                            <tr v-for="(item, k) in rewardItems" :key="k">
                                                <td class="align-middle">{{k+startPage}}</td>
                                                <td class="align-middle">{{convertTimestampToDateTime(item.createDate)}}</td>
                                                <td class="align-middle">{{getOutletName(item.outletID)}}</td>
                                                <td class="align-middle">{{item.title}}</td>
                                                <td class="align-middle">{{item.memberDisplayName}}</td>
                                                <td class="align-middle">{{item.mobile}}</td>
                                            </tr>
                                        </tbody> -->
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import _ from 'lodash';
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {handleSessionExpired, setReturnData, getOutletName} from '@/assets/js/dashboard/dashboard.js'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: "menuReportReward",
    components:{
        DateRangePicker, BreadCrumb
    },
    data(){
        let startDate = moment().startOf('month').toDate();
        let endDate = moment().endOf('month').toDate()
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            search: "", dateRange: { startDate, endDate },
            outlet: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}],
            selectedOutlet: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})},
            isSpinnerShow: false,
            rewardItems: {}, 
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "", rewardExportData: []
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "createDate", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle',},
                { key: "reward", label: this.$i18n.t('table.header.reward'), thClass: 'thead-themed align-middle'},
                { key: "name", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle',},
                { key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "date"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            ret[(this.$i18n.t('table.header.reward')).toUpperCase()] = "rewardTitle"
            ret[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.outlet = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == b.id)[0]
            this.setExportData(this.rewardExportData)
        }
    },
    methods:{
        getOutletName(id){
            return getOutletName(id, this.outlet)
        },
        convertTimestampToDateTime(ts){
            return moment(ts*1000).format(this.$msg.CST.DATE_TIME_24)
        },
        clearFilter(){
            let startDate = moment().startOf('month').toDate();
            let endDate = moment().endOf('month').toDate()

            this.dateRange = {startDate, endDate}
            this.search = ""
            this.selectedOutlet = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}

            this.filterRewardTransaction();
        },
        filterSearchReward(){
            this.filterRewardTransaction()
        },
        filterByDate(date){
            var endDate = date.endDate
            date.endDate = moment(endDate).endOf('day')
            this.dateRange = date
            this.filterRewardTransaction()
        },
        filterByOutlet(item){
            this.selectedOutlet = item
            this.filterRewardTransaction()
        },
        async filterRewardTransaction(){
            var dateFilter = "?startCreateDate=" + moment(this.dateRange.startDate).unix() + "&endCreateDate=" + moment(this.dateRange.endDate).unix()
            var outletFilter = this.selectedOutlet.id == "all" ? "" : "&outletID=" + this.selectedOutlet.id
            var searchFilter = this.search == "" ? "" : "&search=" + this.search

            this.isSpinnerShow = true;
            var result = await this.getRewardTransaction(dateFilter, outletFilter + searchFilter)
            this.rewardItems =  _.groupBy(result.result, 'outletID');
            this.totalPage = result.totalPage;

            this.startPage = result.startPage;
            this.endPage = result.endPage;
            this.isSpinnerShow = false;

            var exportData = await this.getExportData(dateFilter, outletFilter + searchFilter)
            this.rewardExportData = exportData
            this.setExportData(exportData)

        },
        async getRewardTransaction(dateFilter, strFilter){
            let $vm = this
            let QUERY_STRING = dateFilter + "&page=" + $vm.page + strFilter
            const url =  this.$api.REPORT_REWARD + QUERY_STRING;
            
            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = setReturnData(response.data.result, response.data.count, $vm.page)
                $vm.totalEntries = response.data.count;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getExportData(dateFilter, strFilter){
            let $vm = this
            let QUERY_STRING = dateFilter + strFilter
            const url =  this.$api.REPORT_REWARD + QUERY_STRING;
            
            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        setExportData(data){
            this.exportData = []
            var strDate = moment(this.dateRange.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.dateRange.endDate).format(this.$msg.CST.DATE_FORMAT);
           
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_reward`) + " " + strDate
            this.exportHeaders = [this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_reward`), this.$i18n.t('table.header.date') + ": " + strDate , this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV
   

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    date: moment(data[i].createDate*1000).format(this.$msg.CST.DATE_TIME_24),
                    outlet: getOutletName(data[i].outletID, this.outlet),
                    rewardTitle: data[i].title,
                    name: data[i].memberDisplayName,
                    mobile: data[i].mobile,
                })
            }
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterRewardTransaction()
                //document.getElementById('btnToTop').click(); 
            }
        }
    },
    mounted(){
        let $vm = this
        var outlets = JSON.parse($vm.$store.state.outlets);
        $vm.outlet.push(...outlets);

        if (this.outlet[1]) {
            this.selectedOutlet = this.outlet[1]
        }
        
        $vm.filterRewardTransaction();
    },
}
</script>
<style scoped>
.search:hover{
    background: #d6d6d6;
    border: 1px solid #d6d6d6;
}
</style>